module.exports = __webpack_public_path__ + "img/電気回路_2_3_4.cba8cee1.png";